const FORMATTER = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' })

/**
 * €43,00 — the design writes amounts without the space nl-NL puts after the sign. \s also catches
 * the non-breaking space Intl uses there.
 */
export function formatEuro(amount: number): string {
  return FORMATTER.format(amount).replace(/\s/g, '')
}
